import React, { FC, useContext, useEffect } from 'react';
import { useCommon } from '../../../../contexts/CommonContext';
import DailyEngagedUsersContext from '../../../../contexts/DailyEngagedUsersContext';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import DailyEngagedUserMonthlyUsage from '../../../DailyEngagedUsers/components/DailyEngagedUserMonthlyUsage';
import { localization } from '../../localization';

const MonthlyUsageComponent: FC = () => {
  const { dateToSearch, tenant } = useContext(DailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localization);

  useEffect(() => {
    setHeaderContent({
      redirect: '/daily-engaged-users',
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: null });
  }, [dateToSearch]);

  return <DailyEngagedUserMonthlyUsage tableBodyHeight="1000px" registersToTake={-1}></DailyEngagedUserMonthlyUsage>;
};

export default MonthlyUsageComponent;
